<template>
  <div class="typeNav">
    <div class="typeNav_box">
      <ul>
        <li class="typeNav_item">
          <a href="http://cce.scu.edu.cn/" target="_blank">首页</a>
        </li>
        <li class="typeNav_item">
          <a href="http://cce.scu.edu.cn/mana/view/home/pages/recruitPay.jsp" target="_blank">网上缴费</a>
        </li>
        <li class="typeNav_item">
          <a href="http://cce.scu.edu.cn/mana/view/home/newsList.do?type=121" target="_blank">教学运行</a>
        </li>
        <li class="typeNav_item">
          <a href="http://cce.scu.edu.cn/mana/view/home/newsList.do?type=137" target="_blank">考试考务</a>
        </li>
        <li class="typeNav_item">
          <a href="http://cce.scu.edu.cn/mana/view/home/newsList.do?type=136" target="_blank">学籍管理</a>
        </li>
        <li class="typeNav_item">
          <a href="http://cce.scu.edu.cn/mana/view/home/newsList.do?type=530" target="_blank">政策文件</a>
        </li>
        <li class="typeNav_item">
          <a href="http://cce.scu.edu.cn/mana/view/home/newsList.do?type=139" target="_blank">学位</a>
        </li>
      </ul>
    </div>

  </div>
</template>
<script>
export default {
  name: "typeNav",
  data() {
    return {
      
    };
  },
  created() {
    
  },
  methods: {
   
  },
};
</script> 

<style scoped lang="scss">
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.typeNav {
  width: 100%;
  height: 50px;
  .typeNav_box {
    width: 1200px;
    height: 50px;
    margin: 0 auto;
    line-height: 50px;
    .typeNav_item {
      display: inline-block;
      padding-right: 124px;
      &:last-child {
        padding-right: 0;
      }
      a {
        font-size: 16px;
        color: #333;
        text-decoration: none;
        &::before {
          content: "";
          width: 4px;
          height: 4px;
          display: inline-block;
          margin-right: 6px;
          margin-bottom: 4px;
          // border-radius: 2px;
          background-color: #ccc;
        }
        &:hover {
          color: #ba2a17;
        }
      }
    }
  }
}
</style>
